import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import styles from "./ModalLogout.module.css";
import Header from "../Header/Header";
import {
  TextInputField,
  TextInput,
  Select,
  option,
  FilePicker,
  Textarea,
  Checkbox,
  Button,
} from "evergreen-ui";
export const ModalLogout = ({
  open,
  onOpenModal,
  onCloseModal,
  handleDisablebtn,
  data,
  handleSubmit,
}) => {
  return (
    <div>
      <Modal
        open={open}
        showCloseIcon={false}
        onClose={onCloseModal}
        center
        className={styles.mainLogoutModal}
      >
        {/* <Header
          title={"Logout"}
          customMg={"0px"}
          closeBtn={true}
          onClose={onCloseModal}
        /> */}
        <div className={styles.mainLgoutContainer}>
          <div className={styles.logoutimgDiv}>
            <img
              src="./images/stratum/logoutLogo.svg"
              alt=""
              className={styles.logoutLogo}
            />
          </div>

          <div className={styles.MainDivSB}>{data}</div>
          <div className={styles.btnDiv}>
            <Button
              className={styles.submitBtnPO}
              id="poppinFont"
              // marginRight={16}
              onClick={() => handleSubmit()}
              width={120}
            >
              Yes, logout
            </Button>
            <Button
              className="poppinFont"
              width={120}
              // marginRight={16}
              onClick={() => onCloseModal()}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
